import { PERMISSION_KEYS } from 'constants-permissions';
import { useUserDataContext } from 'lane-shared/hooks';
import { hasPermissionOrSuperUser } from 'lane-shared/helpers/hasPermission';

export function hasMarkInvoiceAsBilledPermission(
  user: Parameters<typeof hasPermissionOrSuperUser>[0] | null,
  groupId: string
): boolean {
  return Boolean(
    user &&
      hasPermissionOrSuperUser(
        user,
        [PERMISSION_KEYS.PERMISSION_BILLING_PAYMENTS_INVOICE_MARK_BILLED],
        groupId
      )
  );
}

export function useMarkInvoiceAsBilledPermission(groupId: string): boolean {
  const { user } = useUserDataContext();

  return hasMarkInvoiceAsBilledPermission(user, groupId);
}
